/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type WebhookDataSweepCreated = {
  walletID: string;
  sweepID: string;
};

/** @internal */
export const WebhookDataSweepCreated$inboundSchema: z.ZodType<
  WebhookDataSweepCreated,
  z.ZodTypeDef,
  unknown
> = z.object({
  walletID: z.string(),
  sweepID: z.string(),
});
/** @internal */
export type WebhookDataSweepCreated$Outbound = {
  walletID: string;
  sweepID: string;
};

/** @internal */
export const WebhookDataSweepCreated$outboundSchema: z.ZodType<
  WebhookDataSweepCreated$Outbound,
  z.ZodTypeDef,
  WebhookDataSweepCreated
> = z.object({
  walletID: z.string(),
  sweepID: z.string(),
});

export function webhookDataSweepCreatedToJSON(
  webhookDataSweepCreated: WebhookDataSweepCreated,
): string {
  return JSON.stringify(
    WebhookDataSweepCreated$outboundSchema.parse(webhookDataSweepCreated),
  );
}
export function webhookDataSweepCreatedFromJSON(
  jsonString: string,
): SafeParseResult<WebhookDataSweepCreated, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => WebhookDataSweepCreated$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'WebhookDataSweepCreated' from JSON`,
  );
}
